var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view'),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"text-h5"},[_vm._v(" App is Offline ")]),_c('v-card-text',[_vm._v("Tablet does not have wifi connected.")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }